<template>
  <div>
    <b-modal
      v-if='addArtistsCategoryModal'
      v-model='addArtistsCategoryModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => handleAddArtistsCategory()'
      centered
    >
      <b-row>
        <b-col cols="6" v-for='(locale, i) in locales' :key='i' class='mb-3'>
          <div>
            <label>Nazwa {{ locale }}</label>
            <b-form-input
              v-model="artistsCategoryName[locale]"
            />
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-if='addSceneModal'
      v-model='addSceneModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => handleAddScene()'
      centered
    >
      <b-row>
        <b-col cols="6" v-for='(locale, i) in locales' :key='i' class='mb-3'>
          <label>Nazwa {{ locale }}</label>
          <b-form-input
            v-model="sceneName[locale]"
          />
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
      v-if='addDayModal'
      v-model='addDayModal'
      ok-title="Tak"
      cancel-title="Nie"
      @ok='() => handleAddDay()'
      centered
    >
      <b-row>
        <b-col cols="6" class='mb-3'>
          <label>Data</label>
          <datetime
            type="date"
            input-class="form-control form-control-sm"
            :value="day.date"
            value-zone="local"
            @input='(e) => { day.date = e }'
          />
        </b-col>
      </b-row>    
      <b-row>
        <b-col cols="6" v-for='(locale, i) in locales' :key='i' class='mb-3'>
          <label>Nazwa {{ locale }}</label>
          <b-form-input
            v-model="day.name[locale]"
          />
        </b-col>
      </b-row>
    </b-modal>

    <b-row class='mb-3'>
      <b-col cols="12">
        <b-button-group>
          <b-button variant='outline-primary' size='sm' @click='() => addSceneModal = true'>Dodaj scenę</b-button>
          <b-button variant='outline-primary' size='sm' @click='() => addDayModal = true'>Dodaj dzień</b-button>
          <b-button variant='outline-primary' size='sm' @click='() => addArtistsCategoryModal = true'>Dodaj kategorię</b-button>
        </b-button-group>
      </b-col>
    </b-row>
    
    <b-row class='mb-3'>
      <b-col cols="12" class="pr-0">
        <d-card>
          <d-card-header class="pr-3 pl-3">
            <b-card-title class="h3 mb-0">Daty</b-card-title>
          </d-card-header>

          <d-card-body class="pl-3">
            <b-row v-for="(day, i) in days" :key="i" class='mb-3'>
              <b-col cols="3">
                <label>Data</label>
                <datetime
                  type="date"
                  input-class="form-control form-control-sm"
                  :value="day.date"
                  value-zone="local"
                  @input='(e) => { day.date = e }'
                />
              </b-col>
              <b-col cols="4" v-for='(locale, i) in locales' :key='i' class='mb-3 pl-0'>
                <label>Nazwa {{ locale }}</label>
                <b-form-input
                  class="form-control form-control-sm"
                  v-model="day.name[locale]"
                />
              </b-col>
              <b-col cols="1" class="mt-2 pl-0 pr-0">
                <br />
                <b-button
                  class="float-right"
                  size="sm"
                  @click.prevent='() => handleClickRemoveDay(day)'
                  variant="danger"
                ><b-icon-trash /></b-button>
              </b-col>
            </b-row>
          </d-card-body>
        </d-card>
      </b-col>
    </b-row>

    <b-row class='mb-3'>
      <b-col cols="8" class="pr-0">
        <d-card>
          <d-card-header class="pr-3 pl-3">
            <b-card-title class="h3 mb-0">Sceny</b-card-title>
          </d-card-header>

          <d-card-body class="pl-3">
            <b-row v-for="(scene, i) in form.doc.scenesData.scenes" :key="i" class='mb-3 pl-3'>
              <b-col cols="4" v-for='(locale, i) in locales' :key='i' class='mb-3 pl-0'>
                <label>Nazwa {{ locale }}</label>
                <b-form-input
                  class="form-control form-control-sm"
                  v-model="scene.name[locale]"
                />
              </b-col>

              <b-col cols="4" class="mt-2">
                <br />
                <b-button-group size='sm' class='float-right'>
                  <b-button variant="danger" @click.prevent='() => handleClickRemoveScene(scene)'><b-icon-trash /></b-button>
                  <b-button variant="info" @click='() => handleClickMoveUpScene(i)'><b-icon-caret-up-fill /></b-button>
                  <b-button variant="success" @click='() =>handleClickMoveDownScene(i)'><b-icon-caret-down-fill /></b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </d-card-body>
        </d-card>
      </b-col>

      <b-col cols="4">
        <d-card>
          <d-card-header class="pr-3 pl-3">
            <b-card-title class="h3 mb-0">Kategorie wydarzeń</b-card-title>
          </d-card-header>

          <d-card-body class="pl-3">
            <b-row v-for="(category, i) in categories" :key="i" class='mb-3 pl-3'>
              <b-col cols="5" v-for='(locale, i) in locales' :key='i' class='mb-3 pl-0'>
                <label>Nazwa {{ locale }}</label>
                <b-form-input
                  class="form-control form-control-sm"
                  v-model="category.name[locale]"
                />
              </b-col>
              <b-col cols="2" class="mt-2 pl-0">
                <br />
                <b-button
                  class="float-right"
                  size="sm"
                  @click.prevent='() => handleClickRemoveCategory(category)'
                  variant="danger"
                ><b-icon-trash /></b-button>
              </b-col>
            </b-row>
          </d-card-body>
        </d-card>
      </b-col>
    </b-row>

    <b-row v-bind:key="j" v-for="(scene, j) in form.doc.scenesData.scenes" class="mb-3">
      <b-col cols="12">
        <d-card>
          <d-card-header class="pr-3 pl-3">
            <b-card-title class="h3 mb-0">{{ scene.name.pl }}</b-card-title>
          </d-card-header>

          <d-card-body class="pr-3">
            <days :scene='scene' :daysData='form.doc.daysData' />            
          </d-card-body>
        </d-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
  import { LOCALES, SOCIAL_MEDIA_WRAPPER_OPTIONS } from '@/const'
  import {
    handleSimplePropChanged,
    handleSimplePropWithLocaleChanged,
    handleNestedPropChanged,
    handleEventPropChanged,
    handleAddScene,
    handleAddDay,
    handleAddSceneDate,
    handleRemoveItemFromArray,
    handleAddArtistsCategory,
    handleMoveUpScene,
    handleMoveDownScene,
  } from '@/store/utils'
  import Days from './Days'
  
  import {
    BIconTrash,
    BIconCaretUpFill,
    BIconCaretDownFill,
  } from 'bootstrap-vue'

  export default {
    components: {
      Days,
      BIconTrash,
      BIconCaretUpFill,
      BIconCaretDownFill,
    },
    data() {
      return {
        currentScene: null,
        addSceneModal: false,
        addArtistsCategoryModal: false,
        addDayModal: false,
        sceneName: { pl: '', en: '' },
        day: { name: { pl: '', en: '' }, date: null },
        artistsCategoryName: { pl: '', en: '' },
        locales: LOCALES,
        wrapper_options: SOCIAL_MEDIA_WRAPPER_OPTIONS,
        actions: {
          handleSimplePropChanged,
          handleSimplePropWithLocaleChanged,
          handleNestedPropChanged,
          handleEventPropChanged,
          handleAddScene,
          handleAddDay,
          handleAddSceneDate,
          handleRemoveItemFromArray,
          handleAddArtistsCategory,
          handleMoveUpScene,
          handleMoveDownScene,
        },
      }
    },
    computed: {
      events() {
        return this.$store.state.fanzones.form.doc.scenesData.scenes.map((scene) => scene.events).flat()
      },
      form() {
        return this.$store.state.fanzones.form
      },
      days() {
        return this.$store.state.fanzones.form.doc.daysData.days
      },
      categories() {
        return this.$store.state.fanzones.form.doc.scenesData.artistsCategories || []
      },
    },
    methods: {
      handleAddArtistsCategory() {
        this.actions.handleAddArtistsCategory({ ...this.artistsCategoryName });
      },
      existsEventForDay(day) {
        return !!this.events.find((event) => event && event.dayId && (event.dayId === day.id))
      },
      existsEventsForScene(scene) {
        return scene.events && scene.events.length > 0
      },
      existsEventForCategory(category) {
        return !!this.events.find((event) => event && event.categoryId && (event.categoryId === category.id))
      },
      handleClickRemoveCategory(category) {
        if (confirm(`Usunąć kategorię [${category.name.pl}]?`) === true) {
          if (this.existsEventForCategory(category)) {
            alert("Nie można usunąć, kategorię przypisano do eventu")
          } else {
            this.actions.handleRemoveItemFromArray(this.$store.state.fanzones.form.doc.scenesData, 'artistsCategories', category)
          }
        }
      },
      handleClickRemoveDay(day) {
        if (confirm(`Usunąć dzień [${day.name.pl}]?`) === true) {
          if (this.existsEventForDay(day)) {
            alert("Nie można usunąć, do dnia przypisano eventy!")
          } else {
            this.actions.handleRemoveItemFromArray(this.$store.state.fanzones.form.doc.daysData, 'days', day)
          }
        }
      },
      handleClickRemoveScene(scene) {
        if (confirm(`Usunąć scenę [${scene.name.pl}]?`) === true) {
          if (this.existsEventsForScene(scene)) {
            alert("Nie można usunąć, scena ma przypisane eventy") 
          } else {
            this.actions.handleRemoveItemFromArray(this.$store.state.fanzones.form.doc.scenesData, 'scenes', scene)
          }
        }
        //
      },
      handleAddDay() {
        this.actions.handleAddDay({ ...this.day })
        this.day = { name: { pl: '', en: '' }, date: null }
      },
      handleAddScene() {
        this.actions.handleAddScene({ ...this.sceneName })
        this.sceneName = { pl: '', en: '' }
      },
      handleAddSceneDate() {
        this.actions.handleAddSceneDate(this.currentScene, {...this.day})
        this.day = { name: { pl: '', en: '' }, date: null }
      },
      handleClickMoveUpScene(idx) {
        this.actions.handleMoveUpScene(idx)
      },
      handleClickMoveDownScene(idx) {
        this.actions.handleMoveDownScene(idx)
      },
    },
  }
</script>